import type { BaseEntity } from 'core/base';
import { parsePasteInfo } from '../components/Finder/utils';

export const clipboardReadPasteInfo = <Entity extends BaseEntity>() => {
  const { clipboard } = navigator;

  return (
    clipboard
      .readText()
      .then((text: string) => parsePasteInfo<Entity>(text))
      // eslint-disable-next-line no-console
      .catch(console.error)
  ); // ignore error
};
